export const THEME_STORAGE_KEY = "ess-color-theme";

export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";

export function isThemeValue(value) {
  return value === THEME_LIGHT || value === THEME_DARK;
}
